import _ from 'lodash'

export default {
    methods: {
        preloaded (key, check = true, id = 'data.uuid') {
            const preloaded = _.preload(key)

            if (!check || _.get(preloaded, id) === this.$route.params[_.camelCase(key)]) {
                return preloaded
            }

            return null
        }
    }
}
